const getFirebaseErrorMessage = (error) => {
  const errorCode = error.code;
  
  switch (errorCode) {
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
      return 'Email or password is incorrect. Please check both and try again.';
    case 'auth/email-already-in-use':
      return 'This email is already registered. Please sign in instead.';
    case 'auth/weak-password':
      return 'Password should be at least 6 characters long.';
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/user-not-found':
      return 'No account found with this email. Please sign up first.';
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    case 'auth/too-many-requests':
      return 'Too many failed attempts. Please try again later.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection.';
    case 'auth/popup-closed-by-user':
      return 'Sign-in was cancelled. Please try again.';
    case 'auth/cancelled-popup-request':
      return 'Sign-in was cancelled. Please try again.';
    case 'auth/unauthorized-domain':
      return 'This domain is not authorized in Firebase. Add localhost to Firebase Authentication authorized domains.';
    case 'auth/operation-not-allowed':
      return 'Google sign-in is not enabled in Firebase Authentication. Enable the Google provider in Firebase Console.';
    case 'auth/invalid-api-key':
      return 'Firebase API key is invalid. Recheck client/.env values and restart the app.';
    case 'auth/configuration-not-found':
      return 'Firebase auth configuration is missing for this project. Recheck the Firebase project settings.';
    case 'auth/invalid-phone-number':
      return 'Please enter a valid phone number including the correct country code.';
    case 'auth/missing-phone-number':
      return 'Please enter your mobile number before requesting an OTP.';
    case 'auth/invalid-verification-code':
      return 'The OTP code is incorrect. Please try again.';
    case 'auth/code-expired':
      return 'This OTP has expired. Please request a new code.';
    case 'auth/captcha-check-failed':
      return 'reCAPTCHA verification failed. Please try again.';
    case 'auth/invalid-app-credential':
      return 'Phone verification failed because Firebase rejected the reCAPTCHA/app verification token. For real phone numbers on web, this often happens when the app is running on localhost. Try again from a hosted domain such as Firebase Hosting or an HTTPS tunnel.';
    case 'auth/quota-exceeded':
      return 'SMS quota is temporarily exhausted. Please try again later.';
    case 'auth/provider-already-linked':
      return 'This mobile number is already linked to your account.';
    case 'auth/credential-already-in-use':
      return 'This mobile number is already being used with another account.';
    default:
      return 'Something went wrong. Please try again.';
  }
};

export default getFirebaseErrorMessage;
